import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";
import config from "../../config/config";

// Define a service using a base URL and expected endpoint
export const hatvDocumentListAPI = createApi({
  reducerPath: "hatvDocumentListAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ["hatvDocs"],
  endpoints: (builder) => ({
    getHatvDocumentList: builder.query<any, GoalsAndActionPlansArgTypes>({
      query: ({ affiliateCode, aboNumber, year, type }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/actionplans/year/${year}/type/${type}`,
        method: "GET",
      }),
      providesTags: (result, error, args) => [
        { type : "hatvDocs", id: args.type?.toUpperCase() },
      ]
    }),

    uploadHatvDocumentList: builder.mutation<any, UploadSuccessionArgTypes>({
      query: ({ affiliateCode, aboNumber, payload, type }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/actionplan/create/type/${type}`,
        method: "POST",
        data: payload,
      }),
      invalidatesTags: (result, error, args) => [
        { type : "hatvDocs", id: args.type?.toUpperCase() },
      ]
    }),
    deleteHatvDocumentList: builder.mutation<any, ABOSuccessionIdType>({
      query: ({ id }) => ({
        url: `/am/abo/actionplan/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, args) => [
        { type : "hatvDocs", id: args.type?.toUpperCase() },
      ]
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetHatvDocumentListQuery,
  useUploadHatvDocumentListMutation,
  useDeleteHatvDocumentListMutation,
} = hatvDocumentListAPI;
